import styled from 'styled-components'

// FlatTabbar fills 100% of its container width, so cap the toggle to a compact
// fixed width (two ~40px icon tabs) and keep it from shrinking next to the
// panel title.
export const Toggle = styled.div`
  width: 84px;
  flex-shrink: 0;
`
